module.exports = __webpack_public_path__ + "static/img/8.f881706.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/8.png
// module id = hwZ1
// module chunks = 0